<aside class="impersonation-banner" role="status" aria-live="polite">
  <div class="impersonation-banner__content">
    <span class="impersonation-banner__label">Viewing as</span>
    <span class="impersonation-banner__name">{{ state.impersonatedAs }}</span>
    <span class="impersonation-banner__role">{{ formatRole(state.role) }}</span>
  </div>

  <button
    type="button"
    class="impersonation-banner__action"
    aria-label="Stop impersonation"
    [disabled]="isStopping"
    [attr.aria-busy]="isStopping"
    (click)="handleStopImpersonation()"
  >
    <srm-icon [config]="iconConfig"></srm-icon>
  </button>
</aside>
